import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import logoMenos from '../images/logoMenos79b.png';
import logoDestacado from '../images/logoDestacadosb.png';
import logoNuevo from '../images/logoNuevob.png';
import logoOutlet from '../images/logoOutletb.png';
import '../mioffCanvas.css';
import '../Categories/categories.css';

const MyTooltip = ({titleTooltip,myOffCanvas} ) => {
  const [myTargetURL, setMyTargetURL] = useState('#');
  const [logo, setLogo] = useState('');

  useEffect(() => {
    if (titleTooltip.toLowerCase().includes('menos')) setLogo(logoMenos);
    if (titleTooltip.toLowerCase().includes('destacados')) setLogo(logoDestacado);
    if (titleTooltip.toLowerCase().includes('nuevo')) setLogo(logoNuevo);
    if (titleTooltip.toLowerCase().includes('outlet')) setLogo(logoOutlet);
  
    return 
  }, [])
  

let baseURL= 'https://www.miniso.com.mx/';

const handleLink= (e) =>{
  if (titleTooltip.toLowerCase().includes('menos')) 
    setMyTargetURL(`${baseURL}menos-79`);
  
  if (titleTooltip.toLowerCase().includes('destacados')) 
    setMyTargetURL(`${baseURL}destacados`);
  
  if (titleTooltip.toLowerCase().includes('nuevo')) 
    setMyTargetURL(`${baseURL}lo-nuevo`);
  
  if (titleTooltip.toLowerCase().includes('outlet')) 
    setMyTargetURL(`${baseURL}outlet`);
  
  if (titleTooltip.toLowerCase().includes('valentin')) 
    setMyTargetURL(`${baseURL}san-valentin`);
}
  

  return (
    <OverlayTrigger
        key={"bottom"}
        placement={"bottom"}
        overlay={<Tooltip id={`tooltip-bottom`}>{titleTooltip}</Tooltip>}
      >
        <a style={{textDecoration:'none'}} href={myTargetURL}>
        <div onMouseOver={handleLink} className={myOffCanvas?'d-flex align-items-center text-secondary myOffCanvasHover w-50':'d-flex align-items-center fw-bold small text-dark opacity-75'}>
          {logo!==''&& <img className={myOffCanvas?'me-2':''} src={logo} alt="logo" /> }
          <span className={logo===logoOutlet?'text-danger myOffCanvasHover':''}>{titleTooltip}</span>
        </div>
        </a>
      </OverlayTrigger>
  )
}

export default MyTooltip